import { Component, HostListener, OnDestroy, OnInit } from '@angular/core';
import { ClientQuestionnaireBaseFactory } from './client-questionnaire-base.factory';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ValidationError } from '@pristine-ts/class-validator';
import {
  ClientQuestionnaireOptions,
} from '../../../../../../../../../../common/src/options/client-questionnaire/client-questionnaire.options';
import {
  ClientQuestionnaireModel,
} from '../../../../../../../../../../common/dist/angular/models/client-questionnaire.model';
import {
  ClientQuestionnaireStatusEnum,
} from '../../../../../../../../../../common/src/enums/client-questionnaire/client-questionnaire-status.enum';
import { ClientQuestionnaireStore } from '../../../../stores/client-questionnaire.store';
import { TranslateService } from '@ngx-translate/core';
import {OptionsMapper} from "@magieno/angular-advanced-forms";
import { AlertMessageStore } from '../../../../../core/stores/alert-message.store';
import { FormLifecycleStatusEnum } from '@magieno/angular-advanced-forms';
import { AdvancedFormButton } from "@magieno/angular-advanced-forms";
import { AlertMessageFactory } from '../../../../../core/factories/alert-message.factory';
import { SeverityTypeEnum } from '../../../../../core/enums/severity-type.enum';
import {
  WarningClientQuestionnaireAlreadySubmittedComponent,
} from '../../../warning-client-questionnaire-already-submitted/warning-client-questionnaire-already-submitted.component';
import { AdvancedForm } from "@magieno/angular-advanced-forms";
import { ErrorsUtils } from '../../../../../core/utils/errors.utils';
import {
  WarningClientQuestionnaireContainsErrorsComponent,
} from '../../../warning-client-questionnaire-contains-errors/warning-client-questionnaire-contains-errors.component';
import { LoggingService } from '../../../../../core/services/logging.service';

@Component({
  template: '',
  standalone: false,
})
export class ClientQuestionnaireBase<T extends ClientQuestionnaireOptions> implements OnInit, OnDestroy {
  questionnaireId: string;

  questionnaireSubscription: Subscription;
  formErrorsSubscription: Subscription;

  formServiceOnButtonClickSubscription: Subscription;
  onFormChangeSubscription: Subscription;

  clientQuestionnaireResponse: ClientQuestionnaireModel;

  public lastModified: Date;

  public formStatusEnum: ClientQuestionnaireStatusEnum;

  // @ts-ignore
  public advancedForm: AdvancedForm<T> = this.formFactory.create();
  public numberOfErrors = 0;
  protected optionsType: { new(...args: any[]): object; };

  constructor(protected readonly formFactory: ClientQuestionnaireBaseFactory,
              private readonly clientQuestionnaireStore: ClientQuestionnaireStore,
              protected readonly translateService: TranslateService,
              private readonly activatedRoute: ActivatedRoute,
              public modalService: NgbModal,
              private readonly router: Router,
              private readonly optionsMapper: OptionsMapper,
              // private readonly calculationsUtils: CalculationsUtils,
              private readonly alertMessageStore: AlertMessageStore,
              private readonly errorsUtils: ErrorsUtils,
              private readonly loggingService: LoggingService,
  ) {

    // Start by setting the client questionnaire id
    this.questionnaireId = this.activatedRoute.snapshot.params.questionnaireId;
  }

  ngOnInit(): void {
    // Right away, we want to form to be set as loading.
    this.advancedForm.lifecycleStatus = FormLifecycleStatusEnum.Loading;

    this.activatedRoute.params.subscribe(params => {
      if (params.questionnaireId === undefined) {
        this.loggingService.warning('Questionnaire id not defined');
        return;
      }

      this.questionnaireId = params.questionnaireId;

      // Unsubscribe all the subscriptions on route change.
      this.unsubscribeAll();

      this.advancedForm.lifecycleStatus = FormLifecycleStatusEnum.Loading;

      this.questionnaireSubscription = this.clientQuestionnaireStore.get(this.questionnaireId).subscribe(async (clientQuestionnaireResponse) => {
        if (clientQuestionnaireResponse === undefined) {
          return;
        }
        this.advancedForm.lifecycleStatus = FormLifecycleStatusEnum.ReadyForInput;

        if (clientQuestionnaireResponse.options) {
          // It's important to init the form since when parameters change, we need to reload it entirely.
          // todo: I hope that what I just changed is the expected behavior.
          const options: T = this.optionsMapper.map<T>(new this.optionsType() as T, clientQuestionnaireResponse.options);
          this.advancedForm.setValue(options);

          // this.formService.form.updateModel(clientQuestionnaireResponse.options.options);
        }

        // This following method registers an observable on any button clicked in the form. Each button has an id
        // and that's how we know which button was clicked on.
        if (this.formServiceOnButtonClickSubscription) {
          this.formServiceOnButtonClickSubscription.unsubscribe();
        }
        this.formServiceOnButtonClickSubscription = this.advancedForm.buttonClick$.subscribe(async (button: AdvancedFormButton) => {
          switch (button.id) {
            case 'SAVE':
              await this.trySave();
              break;
            case 'SUBMIT':
              await this.trySubmit();
              break;
          }
        });

        if (this.onFormChangeSubscription) {
          this.onFormChangeSubscription.unsubscribe();
        }
        this.onFormChangeSubscription = this.advancedForm.value$.subscribe((value) => {
          // this.refresh();
        });

        this.clientQuestionnaireResponse = clientQuestionnaireResponse;

        this.formStatusEnum = clientQuestionnaireResponse.status;

        // this.lastModified = this.calculationsUtils.getLastModifiedDate(clientQuestionnaireResponse);

        this.advancedForm.lifecycleStatus = FormLifecycleStatusEnum.ReadyForInput;

        this.postUpdateCallback();

        console.log(this.clientQuestionnaireResponse);
        // await this.form.validate();
        this.refresh();
      });

      this.formErrorsSubscription = this.clientQuestionnaireStore.getErrors(params.questionnaireId).subscribe(errors => {
        this.numberOfErrors = errors.length;
      });
    });
  }

  /**
   * This method exists so that forms extending the base form can be notified when the calculation has
   * been updated and proceed to update some fields.
   */
  postUpdateCallback() {

  }

  ngOnDestroy() {
    this.unsubscribeAll();
  }

  setErrors(validationErrors: ValidationError[]) {
    const errors = this.errorsUtils.getErrors(validationErrors);
    this.clientQuestionnaireStore.setErrors(this.questionnaireId, errors);
  }

  async trySave() {
    // Todo: Error if already completed ?
    await this.save();
  }

  async save() {
    try {
      // We want the form to be disabled  automatically so we set everything to isSending so we can't modify anything.
      this.advancedForm.lifecycleStatus = FormLifecycleStatusEnum.Sending;

      const validationErrors = await this.advancedForm.validate();
      this.setErrors(validationErrors);

      console.log(this.advancedForm.value);
      await this.clientQuestionnaireStore.update(this.questionnaireId, this.advancedForm.value as ClientQuestionnaireOptions);
    } catch (error) {
      this.advancedForm.lifecycleStatus = FormLifecycleStatusEnum.ReadyForInput;
    }
  }

  async trySubmit() {
    if (this.clientQuestionnaireResponse.status !== ClientQuestionnaireStatusEnum.Finalized) {
      await this.submit();
      return;
    }
    const modal = this.modalService.open(WarningClientQuestionnaireAlreadySubmittedComponent);
    modal.closed.subscribe(async result => {
      return;
    });
  }

  async submit() {
    this.advancedForm.lifecycleStatus = FormLifecycleStatusEnum.Sending;

    const validationErrors = await this.advancedForm.validate();
    this.setErrors(validationErrors);
    if (validationErrors && validationErrors.length > 0) {
      const modal = this.modalService.open(WarningClientQuestionnaireContainsErrorsComponent);
      modal.closed.subscribe(async result => {
        if (result === true) {
          this.advancedForm.setButtonLifecycleStatus(FormLifecycleStatusEnum.ReadyForInput);
          this.advancedForm.lifecycleStatus = FormLifecycleStatusEnum.ReadyForInput;
          return;
        } else {
          try {
            await this.clientQuestionnaireStore.forceFinalize(this.questionnaireId, this.advancedForm.value);
          } catch (e) {
            console.error(e);
          }

          await this.router.navigate(['completed'], { relativeTo: this.activatedRoute });
          return;
        }
      });
    }

    try {
      await this.clientQuestionnaireStore.finalize(this.questionnaireId, this.advancedForm.value);

      await this.router.navigate(['completed'], { relativeTo: this.activatedRoute });
    } catch (e) {
      if (e.status === 400 && e.error?.message === 'Validation error') {
        this.alertMessageStore.saveAll(AlertMessageFactory.createValidationAlertMessage(e, SeverityTypeEnum.Error));
      }
    }
    // We reset the form to it's initial state after a successful execution trigger.
    this.advancedForm.setButtonLifecycleStatus(FormLifecycleStatusEnum.ReadyForInput);
    this.advancedForm.lifecycleStatus = FormLifecycleStatusEnum.ReadyForInput;
  }

  refresh() {
  }

  @HostListener('window:beforeunload', ['$event'])
  beforeUnloadHandler(event) {
    if (this.advancedForm.pristine === true ||
      this.formStatusEnum === ClientQuestionnaireStatusEnum.Finalized) {
      return true;
    }
    return false;
  }

  // getStatusText(): string {
  //     return this.calculationsUtils.getStatusText(this.calculationStatusEnum);
  // }
  //
  // getLastModifiedText() {
  //     return this.calculationsUtils.getLastModifiedText(this.lastModified);
  // }

  private unsubscribeAll() {
    this.questionnaireSubscription?.unsubscribe();
    this.formServiceOnButtonClickSubscription?.unsubscribe();
    this.onFormChangeSubscription?.unsubscribe();
    this.formErrorsSubscription?.unsubscribe();
  }
}
